import { FC, PropsWithChildren } from "react";
import { useConsistentClient } from "@/premium/hooks/consistentClient";
import { Footer } from "@/premium/themedComponents/Footer";
import { MenuBar } from "@/premium/themedComponents/MenuBar";
import { OldFooter } from "@/premium/themedComponents/OldFooter";
import { enablePlansPageRedesign } from "@/utils/featureFlags";
import { ThemedHeader } from "./ThemedHeader";

import "./ContentContainer.scss";

export const ContentContainer: FC<PropsWithChildren<{}>> = ({ children }) => {
  useConsistentClient();

  return (
    <>
      <div className="premium-content-container">
        {enablePlansPageRedesign() ? <MenuBar /> : <ThemedHeader />}
        {children}
      </div>
      {enablePlansPageRedesign() ? <Footer /> : <OldFooter />}
    </>
  );
};
